<template>
  <div class="page-form">
    <form class="form">
      <div class="form__global-error" v-if="globalErrors.length">
        {{ globalErrors.join(', ') }}
      </div>
      <div class="form__wrapper">
        <div class="form__item" :class="{ _error: !!errors.email }">
          <label class="form__label" for="formEmailLogin">
            Email
          </label>
          <input id="formEmailLogin" type="text" name="email"
                 class="form__input _email _req"
                 placeholder="Your email"
                 v-model="email" :class="{ _error: !!errors.email }">
          <div class="form__error _icon-error">
            {{ (errors.email || []).join(', ') }}
          </div>
        </div>
        <div class="form__item" :class="{ _error: !!errors.password }">
          <label class="form__label" for="formPassword">
            Password
          </label>
          <input  id="formPassword" name="password"
                  class="form__input _req _password"
                  placeholder="Your password"
                  minlength="4" v-model="password"
                  :class="{ _error: !!errors.email }"
                  :type="showPassword? 'text': 'password'" >
          <div class="form__icon _icon-hide form__viewpass"
               @click="onShowPasswordBtnClick"
               :class="{ _active: showPassword }"></div>
          <div class="form__error _icon-error">
            {{ (errors.password || []).join(', ') }}
          </div>
        </div>
      </div>
      <div class="form__controls">
        <div class="form__submit">
          <button type="button" class="page-button" @click="onLoginBtnClick">
            <span></span><span>Login</span><span></span>
          </button>
        </div>
        <div class="form__policy">
          <a href = "#" @click="onForgotBtnClick">
            Forgot password?
          </a>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import Auth from '@/lib/auth';
import { showForgotPasswordModal } from '@/lib/modal_utils';

export default {
    name: "LoginForm",

    events: ['close', 'loginSuccess'],

    props: {
        eventsOnly: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            email: '',
            password: '',
            showPassword: false,
            errors: {
                email: '',
                password: '',
                ip: '',
                __all__: '',
            }
        };
    },

    computed: {
        globalErrors() {
            return [
                ...((this.errors.ip || [])),
                ...((this.errors.__all__ || [])),
            ];
        }
    },

    methods: {
        onLoginBtnClick() {
            Auth.login({
                email: this.email,
                password: this.password,
                success: this.onLoginSuccess,
                error: this.onLoginError
            });
        },

        onLoginSuccess(res) {
            this.errors = res.errors || {};
            if (res.msg === 'login successful') {
                if (this.eventsOnly) {
                     this.$emit('loginSuccess');
                } else if (this.$route.matched.some((route) => route.name === 'client-area')) {
                    this.$emit('close', {pageReload: true});
                } else {
                    window.location.href = this.$router.resolve({name: 'client-area'}).fullPath;
                }
            }
        },

        onLoginError() {
            console.log('------------ TODO AUTH LOGIN HANDLE ERROR!')
        },

        onForgotBtnClick() {
            this.$emit('close', {pageReload: false});
            showForgotPasswordModal();
        },

        onShowPasswordBtnClick() {
            this.showPassword = !this.showPassword;
        },
    }
}
</script>

<style scoped>
.form {
  width: 270px;
}

.form__global-error {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 16px;
  padding: 12px 14px;
  border: 1px solid #f05a5a;
  border-radius: 6px;
  background: rgba(240, 90, 90, 0.12);
  color: #ff6b6b;
  font-weight: 600;
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>


<style scoped>
.form__global-error {
  margin-bottom: 16px;
  padding: 12px 14px;
  border: 1px solid #f05a5a;
  border-radius: 6px;
  background: rgba(240, 90, 90, 0.12);
  color: #ff6b6b;
  font-weight: 600;
  line-height: 1.4;
}
</style>
